export class BaseModel {
    id: string;
}
